import React, { useEffect, useRef, useState } from 'react'

import intl from 'components/i18n/ReactIntlWrapper'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { AccountTree, Save } from '@mui/icons-material'
interface AddStateModalProps {
    open: boolean
    setOpen: (open: boolean) => void
    onAddState: (stateName: string) => void
}

const AddStateModal: React.FC<AddStateModalProps> = ({ open, setOpen, onAddState }) => {
    const [stateName, setStateName] = useState<string>('')

    const handleAddState = () => {
        onAddState(stateName)
        onRequestClose()
    }

    const handleOpen = () => {
        setOpen(true)
    }

    const onRequestClose = () => {
        setStateName('')
        setOpen(false)
    }

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (open) {
            setStateName('')
            setTimeout(() => {
                inputRef.current.focus()
            }, 1)
        }
    }, [open]);

    return (
        <>
            <Button size='small' variant='contained' color='primary' className='newAddress' onClick={handleOpen}>
                <AccountTree />
                <span className="px-2">{intl.get('workflowDetail.addNewState')}</span>
            </Button>
            <Dialog
                open={open}
                onClose={onRequestClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { overflow: 'visible' }
                }}
            >
                <DialogTitle className='py-2 px-3'>{intl.get('workflowDetail.addNewState')}</DialogTitle>
                <DialogContent sx={{ pt: 3, pb: 2, px: 3, overflow: 'visible' }}>
                    <TextField
                        id="stateName"
                        inputRef={inputRef}
                        label={intl.get('editableNode.placeholder.nodeName')}
                        fullWidth
                        size="small"
                        type="text"
                        inputProps={{ maxLength: 100 }}
                        value={stateName}
                        onKeyDown={(e) => e.key === 'Enter' && stateName?.length && handleAddState()}
                        onChange={(e) => setStateName(e.target.value)}
                        placeholder={intl.get('addStateModal.placeholder')}
                        slotProps={{
                            inputLabel: { shrink: true }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color='inherit' onClick={onRequestClose}>
                        {intl.get('cancel.button')}
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        type="submit"
                        onClick={handleAddState}
                        disabled={stateName === '' ? true : false}
                        startIcon={<Save/>}
                    >
                        {intl.get('save.button')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AddStateModal
